import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, annotationPlugin);

interface Props {
    value: number;
    title?: string;
    heightPx?: number; // altura do gráfico em pixels, padrão 100px
    faixas: { label: string; cor: string; min: number; max: number }[];
}

const RangeIndicatorChart: React.FC<Props> = ({ title, value, heightPx = 50, faixas }) => {
    const barWidth = 20;
    const yMin = 0;
    const yMax = 1;
    const yCenter = (yMin + yMax) / 2;
    const xMin = Math.min(...faixas.map(f => f.min));
    const xMax = Math.max(...faixas.map(f => f.max));

    const chartData = {
        labels: [''],
        datasets: [
            {
                label: title || 'Valor',
                data: [{ x: value, y: yCenter }],
                pointBackgroundColor: 'black',
                pointStyle: 'rectRot', // estilo de retângulo "em pé"
                pointRadius: barWidth / 2,
                pointHoverRadius: barWidth / 2,
                rotation: 0,
                showLine: false,
            },
        ],
    };

    const chartOptions: any = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                min: xMin,
                max: xMax,
                ticks: { stepSize: 5 },
                title: {
                    display: false,
                    text: title || 'Valor',
                    padding: {
                        top: 10,    // espaço acima do texto
                        bottom: -10, // espaço abaixo do texto — aumentar esse valor "desce" o título
                    },
                },
            },
            y: {
                min: yMin,
                max: yMax,
                display: false,
            },
        },
        plugins: {
            legend: { display: false },
            annotation: {
                annotations: faixas.map((faixa) => ({
                    type: 'box',
                    xMin: faixa.min,
                    xMax: faixa.max,
                    yMin,
                    yMax,
                    backgroundColor: faixa.cor + '55',
                })),
            },
        },
    };

    return (
        <>
        <div style={{ height: heightPx, marginBottom: '1rem' }}>
            <Line data={chartData} options={chartOptions} />
        </div>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 8 }}>
                {faixas.map((faixa) => (
                    <div key={faixa.label} style={{ textAlign: 'center' }}>
                        <div
                            style={{
                                width: 20,
                                height: 10,
                                backgroundColor: faixa.cor,
                                margin: '0 auto',
                                borderRadius: 2,
                            }}
                        />
                        <small>{faixa.label}</small>
                    </div>
                ))}
            </div>
            </>
    );
};

export default RangeIndicatorChart;
